import room1 from "../../img/roomOne.jpg";
import room2 from "../../img/roomTwo.jpg";
import room3 from "../../img/partyRoom.jpg";
import room4 from "../../img/roomFour.jpg";
import room5 from "../../img/roomFive.jpg";



export const room = [
  {
    id: 1,
    name: "studio double",
    price: "£50",
    img: `${room1}`,
    desc:
      "Lorem ipsum dolor, sit amet consectetur adipisicing elit. Reprehenderit deleniti quae distinctio rem laborum nostrum, a accusamus culpa et saepe minus in illum doloribus numquam non voluptate blanditiis illo dicta!",
    guests: "2",
  },
  {
    id: 2,
    name: "deluxe double",
    price: "£75",
    img: `${room2}`,
    desc:
      "Lorem ipsum dolor, sit amet consectetur adipisicing elit. Reprehenderit deleniti quae distinctio rem laborum nostrum, a accusamus culpa et saepe minus in illum doloribus numquam non voluptate blanditiis illo dicta!",
    guests: "2",
  },
  {
    id: 3,
    name: "luxury creek",
    price: "£87",
    img: `${room3}`,
    desc:
      "Lorem ipsum dolor, sit amet consectetur adipisicing elit. Reprehenderit deleniti quae distinctio rem laborum nostrum, a accusamus culpa et saepe minus in illum doloribus numquam non voluptate blanditiis illo dicta!",
    guests: "3",
  },
  {
    id: 4,
    name: "premier suite",
    price: "£95",
    img: `${room4}`,
    desc:
      "Lorem ipsum dolor, sit amet consectetur adipisicing elit. Reprehenderit deleniti quae distinctio rem laborum nostrum, a accusamus culpa et saepe minus in illum doloribus numquam non voluptate blanditiis illo dicta!",
    guests: "4",
  },
  {
    id: 5,
    name: "royale cove",
    price: "£115",
    img: `${room5}`,
    desc:
      "Lorem ipsum dolor, sit amet consectetur adipisicing elit. Reprehenderit deleniti quae distinctio rem laborum nostrum, a accusamus culpa et saepe minus in illum doloribus numquam non voluptate blanditiis illo dicta!",
    guests: "5",
  },
];
